import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "kind",
    "companyName",
    "countryCode",
    "vin",
    "tin",
    "tinLabelIndividual",
    "tinLabelCompany",
  ]

  connect() {
    this.update()
  }

  update() {
    // TIN label
    this.#show(this.tinLabelIndividualTarget, this.#isIndividualOrBlank())
    this.#show(this.tinLabelCompanyTarget, !this.#isIndividualOrBlank())

    // Updates here should also:
    // - be applied to the component as hidden defaults
    // - match validations in the LegalEntity model
    this.#show(this.companyNameTarget, this.#isCompany())
    this.#show(this.vinTarget, this.#isEuropean() && this.#isBusiness())
    this.#show(this.tinTarget, this.#isEuropean())
  }

  #isCompany() {
    return this.kindTarget.value == "company"
  }

  #isBusiness() {
    return (
      this.kindTarget.value == "company" ||
      this.kindTarget.value == "individual_company"
    )
  }

  #isIndividualOrBlank() {
    return this.#isIndividual() || this.kindTarget.value == ""
  }

  #isIndividual() {
    return this.kindTarget.value == "individual"
  }

  #isEuropean() {
    const country = this.countryCodeTarget.selectedOptions[0]
    return country?.dataset?.legalEntityEuropean == "true"
  }

  #show(element, show) {
    if (show) {
      element.removeAttribute("hidden")
    } else {
      element.setAttribute("hidden", true)
    }
  }
}
